import AppModal from 'components/modal/Modal'
import { Button } from 'components/UI'
import { useNavigate } from 'react-router'

const MobileComplianceMobile = ({ open, onClose }) => {
  const navigate = useNavigate()
  return (
    <AppModal open={open}>
      <div className=" w-full p-4 bg-[#FEEBDD] py-10 rounded-xl text-[#F67443]">
        <h2 className="text-2xl text-[#F67443] font-semibold  text-left">
          Desktop or Laptop Required{' '}
        </h2>
        <img src="/assets/image/desktop-view.png" className="w-full mt-6" alt="" />
        <p className="my-4">You’re currently using a mobile or tablet device.</p>
        <p className="mt-4">
          To create or log into an account, please use a desktop or laptop computer.
        </p>

        {onClose ? (
          <Button className={'w-full my-6'} onClick={onClose}>
            Close
          </Button>
        ) : (
          <Button className={'w-full my-6'} onClick={() => navigate('/')}>
            Back Home
          </Button>
        )}
      </div>{' '}
    </AppModal>
  )
}

export default MobileComplianceMobile
